import React, { createContext, useContext, useState, useEffect } from 'react';

const WebContext = createContext();

const defaultServices = [
  // === BIRD NETS ===
  {
    id: 'balcony-safety-nets',
    title: 'Balcony Safety Nets',
    category: 'Bird Nets',
    shortDesc: 'Ensure absolute safety for kids, family, and pets on your balcony.',
    image: 'https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹15/sq.ft',
    benefits: ['High durability UV-stabilized nylon', '150kg load-bearing capacity', 'Transparent view & full airflow', 'Professional anchoring'],
    longDesc: 'Prevent accidental falls from high-rise balconies. Made of heavy-duty, UV-stabilized nylon, Vengamamba balcony safety nets are weather-proof, rust-free, and designed to secure balcony margins without blocking fresh light and ventilation.',
    faqs: [{ q: 'How long do they last?', a: 'They easily last for 5 to 7 years under direct sunlight.' }]
  },
  {
    id: 'kids-safety-nets-for-balcony',
    title: 'Kids Net For Balcony',
    category: 'Bird Nets',
    shortDesc: 'Special heavy-duty safety nets designed to prevent child accidents.',
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹18/sq.ft',
    benefits: ['Thicker multi-strand knots', 'Double wall anchors', 'Soft scratch-free surface', 'Tested weight hold up to 200kg'],
    longDesc: 'Children are curious by nature. Our specialized kids safety nets offer thick nylon cords and close knit spacing to ensure toddlers and children are 100% secure from balcony gaps.',
    faqs: [{ q: 'What is the strength rating?', a: 'Tested to support up to 200kg weight impact.' }]
  },
  {
    id: 'pet-safety-nets',
    title: 'Pets Safety Nets',
    category: 'Bird Nets',
    shortDesc: 'Bite-resistant and claw-resistant safety nets for cats and dogs.',
    image: 'https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹16/sq.ft',
    benefits: ['Reinforced bite-proof strands', 'Small mesh size (1.2")', 'Perfect tensioning', 'No room to squeeze through'],
    longDesc: 'Cats and dogs love looking outside. Our pet safety nets are designed with claw-proof synthetic filaments to ensure your curious pets stay safe from falling through window sills and balcony openings.',
    faqs: [{ q: 'Can cats bite through it?', a: 'Our filaments are extra-toughened to resist pet chewing.' }]
  },
  {
    id: 'pigeon-nets',
    title: 'Pigeon Nets',
    category: 'Bird Nets',
    shortDesc: 'Strong HDPE netting blockades for pigeons and large birds.',
    image: 'https://images.unsplash.com/photo-1596464716127-f2a82984de30?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹12/sq.ft',
    benefits: ['100% pigeon entry exclusion', 'No harm physical barrier', 'Unyielding HDPE wire', 'Hygiene protection'],
    longDesc: 'Prevent pigeons from nesting, polluting, and creating health risks on AC ledges, window sills, and corridors using Vengamamba Enterprises premium HDPE pigeon netting.',
    faqs: [{ q: 'Does it harm the birds?', a: 'No, it serves as a physical barrier and deterrent without injuring them.' }]
  },
  {
    id: 'pigeon-safety-nets',
    title: 'Pigeon Safety Nets',
    category: 'Bird Nets',
    shortDesc: 'Double-duty safety netting combining pigeon protection and fall safety.',
    image: 'https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹14/sq.ft',
    benefits: ['Heavy-duty gauge cord', 'Dual safety & hygiene features', 'Tight mesh structure', 'Weather proof nylon coating'],
    longDesc: 'Combining high-impact fall protection with complete pigeon exclusion. Prefect for balconies where both bird droppings prevention and child safety are required.',
    faqs: [{ q: 'What is the mesh size?', a: 'Typically 1.2 inches to ensure birds cannot enter and kids cannot slip through.' }]
  },
  {
    id: 'pigeon-net-installation',
    title: 'Pigeon Nets Installation',
    category: 'Bird Nets',
    shortDesc: 'Professional high-rise pigeon net mounting and custom rope-access services.',
    image: 'https://images.unsplash.com/photo-1596464716127-f2a82984de30?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Toll-Free Installation Services',
    benefits: ['Trained rope-access climbers', 'High-rise apartment specialists', 'Secure steel wall anchoring', 'Same-day completion'],
    longDesc: 'Expert team specialized in reaching difficult window corners, high ducts, plumbing pipes, and vertical shafts. Quick, clean, and completely safe installation methods.',
    faqs: [{ q: 'Is scaffolding required?', a: 'No, our crew uses certified rope climbing gear for high-rise installations.' }]
  },
  {
    id: 'bird-spikes',
    title: 'Bird Spikes',
    category: 'Bird Nets',
    shortDesc: 'Polycarbonate and stainless steel spikes for ledges, beams and pipes.',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹45/linear ft',
    benefits: ['Stainless Steel SS-304 wire', 'Weatherproof polycarbonate base', 'Easy glue/screw mounting', 'Zero maintenance'],
    longDesc: 'Humane bird deterrent spikes to prevent pigeons and other birds from landing or roosting on parapet walls, beams, pipes, and signboards.',
    faqs: [{ q: 'Do spikes hurt the birds?', a: 'No, they simply prevent them from landing comfortably, making them fly elsewhere.' }]
  },
  {
    id: 'bird-protection-nets',
    title: 'Bird Protection Nets',
    category: 'Bird Nets',
    shortDesc: 'Comprehensive bird exclusionary netting for houses, flats, and villas.',
    image: 'https://images.unsplash.com/photo-1596464716127-f2a82984de30?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹13/sq.ft',
    benefits: ['Keeps out crows, pigeons & sparrows', 'UV-shielded HDPE cords', 'Rust-proof installations', 'Clean aesthetics'],
    longDesc: 'Protect your building ducts, corridors, and gardens from all kinds of flying pests. Our customizable mesh structures provide permanent bird-free spaces.',
    faqs: [{ q: 'Are they visible from a distance?', a: 'No, our thin transparent/mesh nets are virtually invisible from the ground.' }]
  },
  {
    id: 'anti-bird-nets',
    title: 'Anti Bird Nets',
    category: 'Bird Nets',
    shortDesc: 'Tough physical barrier nets designed to repel birds from windows & rooftops.',
    image: 'https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹14/sq.ft',
    benefits: ['Eco-friendly bird control', 'Strong UV stabilization', 'Rust-proof hooks', '5-year warranty support'],
    longDesc: 'Install anti-bird nets to safeguard commercial spaces, windows, and open yards. Ideal for prevention of nesting and keeping balcony areas clear of bird nests.',
    faqs: [{ q: 'What material is used?', a: 'Premium co-polymer nylon with high UV stabilization.' }]
  },
  {
    id: 'pigeon-nets-for-balconies',
    title: 'Pigeon Nets For Balconies',
    category: 'Bird Nets',
    shortDesc: 'Specifically tailored pigeon exclusion screens for apartment balconies.',
    image: 'https://images.unsplash.com/photo-1596464716127-f2a82984de30?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹12/sq.ft',
    benefits: ['Full cover blockades', 'Custom-fit measurements', 'Strong anchoring cables', 'Clear visibility'],
    longDesc: 'Perfect solution for balcony safety against nesting pigeons. Keeps your washing machine areas, balcony chairs, and floor completely clean and germ-free.',
    faqs: [{ q: 'Will it collect dust?', a: 'No, the mesh is self-cleaning during normal rains.' }]
  },
  {
    id: 'sparrow-protection-nets',
    title: 'Sparrow Protection Nets',
    category: 'Bird Nets',
    shortDesc: 'Micro-mesh netting to prevent small sparrows and birds from entering spaces.',
    image: 'https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹16/sq.ft',
    benefits: ['Ultra-small mesh grid (0.75")', 'Excludes tiny sparrows & bats', 'Strong nylon filament', 'Tension wire boundary'],
    longDesc: 'Designed to exclude small bird species like sparrows, swifts, and bats from nesting in louvers, corridors, and false ceilings. Features a very fine, durable mesh grid.',
    faqs: [{ q: 'Can bats get through this?', a: 'No, the 0.75" mesh size is too small for bats to pass.' }]
  },
  {
    id: 'anti-seagull-nets',
    title: 'Anti Seagull Nets',
    category: 'Bird Nets',
    shortDesc: 'Extra-strong heavy-duty boundary nets designed for coastal properties.',
    image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹22/sq.ft',
    benefits: ['Thick gauge HDPE cord', 'Saltwater resistant', 'High wind shear tolerance', 'Heavy-duty steel anchors'],
    longDesc: 'Specialized for sea-facing buildings and coastal areas where large birds like seagulls cause noise and structural dirt. Coated with anti-saline and UV-block agents.',
    faqs: [{ q: 'Is it rust proof?', a: 'Yes, we use SS-316 grade stainless steel anchors to resist sea-salt corrosion.' }]
  },
  {
    id: 'grill-balcony-safety-nets',
    title: 'Grill Balcony Safety Nets',
    category: 'Bird Nets',
    shortDesc: 'Combination mesh nets installed over existing iron grills for safety.',
    image: 'https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹14/sq.ft',
    benefits: ['Reinforces open grill gaps', 'Prevents toddlers throwing toys', 'Prevents bird entry', 'Zip-tie & wire locks'],
    longDesc: 'If your balcony has iron grills but wide open margins, our grill safety nets wrap tightly around them to make the space secure for infants and block birds completely.',
    faqs: [{ q: 'Can it be installed on curved grills?', a: 'Yes, our technicians custom-shape the net over any grill design.' }]
  },
  {
    id: 'terrace-safety-nets',
    title: 'Terrace Top Nets',
    category: 'Bird Nets',
    shortDesc: 'Full rooftop coverage nets to prevent falls and bird nesting.',
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹18/sq.ft',
    benefits: ['Full boundary coverage', 'High wind endurance', 'Allows rooftop games', 'UV-stabilized copolymer'],
    longDesc: 'Protect your building terrace margins. Essential for apartments where kids play on rooftops. Prevents accidents and blocks birds from roosting on parapets.',
    faqs: [{ q: 'Can it withstand high wind speeds?', a: 'Yes, we install high-tension anchor cables designed for high altitudes.' }]
  },
  {
    id: 'industrial-safety-nets',
    title: 'Industrial Safety Nets',
    category: 'Bird Nets',
    shortDesc: 'Heavy fall arrest nets for factories, warehouses, and crane bays.',
    image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Custom Quote Available',
    benefits: ['Knotless polypropylene mesh', 'Meets OSHA safety norms', 'High load capacity (500kg+)', 'Debris mesh liner options'],
    longDesc: 'Prevent warehouse roof fall accidents and protect materials. Perfect for roof repair personnel safety and warehouse cargo safety partitioning.',
    faqs: [{ q: 'Are they fire retardant?', a: 'Yes, we provide flame-retardant industrial netting upon request.' }]
  },
  {
    id: 'building-safety-nets',
    title: 'Building Safety Nets',
    category: 'Bird Nets',
    shortDesc: 'Debris collection and worker protection nets for construction sites.',
    image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Custom Quote Available',
    benefits: ['Construction code compliant', 'Prevents brick/tool drops', 'Protects ground crews', 'Tough weather proofing'],
    longDesc: 'Prevent site hazards and comply with construction safety regulations. Arrests falls of personnel, tools, and construction materials in multi-story projects.',
    faqs: [{ q: 'Do you offer installation certificates?', a: 'Yes, we provide quality and safety compliance reports after installation on demand.' }]
  },
  {
    id: 'duct-area-safety-nets',
    title: 'Duct Area Safety Nets',
    category: 'Bird Nets',
    shortDesc: 'Vertical shaft netting to seal building shafts and prevent bird entry.',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹14/sq.ft',
    benefits: ['Plumbing shaft protection', 'Stops pigeon nesting', 'Saves shaft cleaning costs', 'Robust wall anchor bolts'],
    longDesc: 'Shafts are prime nesting spots for pigeons, causing bad smells and germ transmission. Our duct area safety nets seal plumbing areas permanently.',
    faqs: [{ q: 'Is it hard to clean plumbing lines after?', a: 'Our nets feature quick-opening hooks for maintenance access.' }]
  },
  {
    id: 'open-area-safety-nets',
    title: 'Open Area Safety Nets',
    category: 'Bird Nets',
    shortDesc: 'Horizontal coverage nets for large yards, open spaces, and courtyards.',
    image: 'https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹18/sq.ft',
    benefits: ['Spans large open voids', 'Maintains natural light', 'Prevents birds nesting', 'Tension cable grid'],
    longDesc: 'Ideal for central building courtyards, school yards, and large building voids. Seals off open air spaces completely from birds while letting light and rain through.',
    faqs: [{ q: 'How is it supported?', a: 'Using high-tensile structural cables anchored to the surrounding walls.' }]
  },
  {
    id: 'staircase-safety-nets',
    title: 'Staircase Safety Nets',
    category: 'Bird Nets',
    shortDesc: 'Vertical netting to block staircase open-wells in high-rise buildings.',
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹15/sq.ft',
    benefits: ['Secures staircase voids', 'Protects kids from fall hazards', 'Tightly pulled nylon cords', 'Neat vertical lines'],
    longDesc: 'High-rise apartment staircase open-wells present fall hazards. Our staircase safety nets provide vertical wall-to-wall security in multi-story stairs.',
    faqs: [{ q: 'Is it fire safe?', a: 'Yes, our nylon fibers have high heat tolerance.' }]
  },
  {
    id: 'construction-safety-nets',
    title: 'Construction Safety Nets',
    category: 'Bird Nets',
    shortDesc: 'High-impact fall arrest screens for workers on high-rise structures.',
    image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Custom Quote Available',
    benefits: ['Heavy-duty impact absorption', 'Double border reinforcement', 'OSHA compliant', 'Rapid setup hook systems'],
    longDesc: 'Keep high-altitude workers safe. Construction safety netting serves as a reliable guard for elevated construction slabs, scaffolds, and elevator shafts.',
    faqs: [{ q: 'Do you offer site testing?', a: 'Yes, we test anchor load capacities post-installation.' }]
  },
  {
    id: 'swimming-pool-safety-nets',
    title: 'Swimming Pool Safety Nets',
    category: 'Bird Nets',
    shortDesc: 'Strong pool covers to prevent accidental drowning of children and pets.',
    image: 'https://images.unsplash.com/photo-1508098682722-e99c43a406b2?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹25/sq.ft',
    benefits: ['Waterproof synthetic material', 'UV & chlorine resistant', 'Quick tensioning tool', 'Holds weight of adults'],
    longDesc: 'Drowning prevention is vital for families with pools. Our pool safety nets cover the pool surface securely, preventing children and pets from falling in.',
    faqs: [{ q: 'Is it easy to remove?', a: 'Yes, one person can put on or take off the net in under 10 minutes.' }]
  },
  {
    id: 'monkey-safety-nets',
    title: 'Monkey Net For Balconies',
    category: 'Bird Nets',
    shortDesc: 'Thicker, ultra-durable nets to keep monkeys out of balconies and gardens.',
    image: 'https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹20/sq.ft',
    benefits: ['Extra-thick nylon cord', 'Resists tearing and clawing', 'Double-locked steel hooks', 'Protects potted plants'],
    longDesc: 'Monkeys can easily tear through standard bird netting. We install specialized thick co-polymer nets that resist monkey attacks, keeping balconies safe.',
    faqs: [{ q: 'Will monkeys break this?', a: 'No, we use 2.5mm thick high-impact filaments that withstand monkey grip.' }]
  },
  {
    id: 'car-parking-safety-nets',
    title: 'Car Parking Safety Nets',
    category: 'Bird Nets',
    shortDesc: 'Keeps birds from nesting under parking lot roof beams and staining cars.',
    image: 'https://images.unsplash.com/photo-1596464716127-f2a82984de30?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹13/sq.ft',
    benefits: ['Stops acidic bird droppings', 'Protects car paint finishes', 'Covers overhead trusses', 'High durability'],
    longDesc: 'Bird droppings corrode car paint. We seal the parking roof ceilings and steel trusses to keep pigeons away, keeping your parking bays clean.',
    faqs: [{ q: 'Will it block overhead sprinkler systems?', a: 'No, the mesh permits water from sprinklers to pass through freely.' }]
  },
  {
    id: 'coconut-tree-safety-nets',
    title: 'Coconut Tree Safety Nets',
    category: 'Bird Nets',
    shortDesc: 'High-strength mesh cages to catch falling coconuts and prevent injuries.',
    image: 'https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹35/tree',
    benefits: ['Prevents coconut drop injury', 'Saves cars and roofs below', 'Strong mesh pocket design', 'Easy checkups'],
    longDesc: 'Coconuts falling from tall trees pose hazards. We wrap high-strength nets below the coconut clusters to catch falling fruit safely.',
    faqs: [{ q: 'Does it affect tree growth?', a: 'Not at all, it only catches loose coconuts and dried fronds.' }]
  },
  {
    id: 'hdpe-nets',
    title: 'HDPE Nets , Nylon Nets',
    category: 'Bird Nets',
    shortDesc: 'High-Density Polyethylene and co-polymer nylon nets for sun protection and bird barriers.',
    image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹12/sq.ft',
    benefits: ['UV stabilizer treated', 'Rot-resistant polymer', 'High-tensile strength', 'Aesthetic mesh'],
    longDesc: 'High-Density Polyethylene and copolymer nylon nets offer great chemical resistance and tensile strength. Best for open balconies, farm boundaries, and ducts.',
    faqs: [{ q: 'What colors are available?', a: 'Available in black, white, blue, and green.' }]
  },

  // === INVISIBLE GRILLS ===
  {
    id: 'invisible-grills-for-balcony',
    title: 'Invisible Grill For Balcony',
    category: 'Invisible Grills',
    shortDesc: 'Ultra-thin marine-grade SS cable safety screens for unblocked balcony views.',
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹75/sq.ft',
    benefits: ['316 marine-grade steel wire', 'Protective nylon coating', 'Unobstructed scenic view', 'Built-in security alarm support'],
    longDesc: 'Modern replacement for heavy metal grills. Made of 316-grade stainless steel cables wrapped in protective nylon, offering absolute safety for balconies.',
    faqs: [{ q: 'Will it rust?', a: 'We use high-grade SS-316 which is immune to rust and weather corrosion.' }]
  },
  {
    id: 'invisible-safety-grills-for-balcony',
    title: 'Invisible Safety Grills For Balcony',
    category: 'Invisible Grills',
    shortDesc: 'Highly tensioned steel wire safety systems for high-rise balconies.',
    image: 'https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹78/sq.ft',
    benefits: ['High tensile strength wire', 'Kid & pet proof spacing', 'Stainless steel frame structure', 'Clean modern look'],
    longDesc: 'Keep your building look clean while ensuring safety. Cables are spaced 2 to 3 inches apart to provide robust safety for families.',
    faqs: [{ q: 'Can it hold the weight of an adult?', a: 'Yes, our cable grids are tensioned to withstand loads of up to 150kg.' }]
  },
  {
    id: 'invisible-grills-for-windows',
    title: 'Invisible Grill For Windows',
    category: 'Invisible Grills',
    shortDesc: 'Sleek structural steel wire grills replacing bulky iron window bars.',
    image: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹70/sq.ft',
    benefits: ['Lets in light and air', 'Quick emergency escape cut', 'No rust stains on walls', 'SS-316 high tension cables'],
    longDesc: 'Enjoy natural ventilation without blocking window views. The thin cables offer high-security window guarding with escape routes for fire safety.',
    faqs: [{ q: 'How do we escape in an emergency?', a: 'cables can be cut using a specialized wire cutter in case of emergency.' }]
  },
  {
    id: 'staircase-invisible-grills',
    title: 'Staircase Invisible Grills',
    category: 'Invisible Grills',
    shortDesc: 'Vertical steel wire barriers to secure staircase wells in apartments.',
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹80/sq.ft',
    benefits: ['Secures open well zones', 'Sleek architectural look', 'Rust-free installation', 'Clutter-free design'],
    longDesc: 'Safeguard open stairwells and mezzanine stairs using high-tensile stainless steel wire. Essential for schools, malls, and apartments.',
    faqs: [{ q: 'Is it safe for schools?', a: 'Highly recommended for schools to prevent accidents in open staircase shafts.' }]
  },
  {
    id: 'stainless-steel-invisible-grills',
    title: 'Stainless Steel Invisible Grills',
    category: 'Invisible Grills',
    shortDesc: 'Premium SS-316 wire grills offering safety and premium aesthetics.',
    image: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹85/sq.ft',
    benefits: ['SS-316 marine-grade wire', 'Rust-proof warranty', 'Coated with anti-UV nylon', 'High tensile tensioners'],
    longDesc: 'Our finest grade invisible grills. Designed to resist coastal salty breeze, dust, and rainfall, maintaining a transparent view for years.',
    faqs: [{ q: 'What is the warranty?', a: 'Includes a 5-year anti-rust warranty.' }]
  },

  // === SPORTS NETS ===
  {
    id: 'cricket-practice-nets',
    title: 'Cricket Practice Nets',
    category: 'Sports Nets',
    shortDesc: 'Premium pitch netting enclosures for schools, academies, and backyards.',
    image: 'https://images.unsplash.com/photo-1508098682722-e99c43a406b2?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹20/sq.ft',
    benefits: ['High impact absorption cord', 'Heavy-mesh structure', 'Strong steel pole supports', 'Monsoon-proof material'],
    longDesc: 'Practice batting and bowling without losing balls. We set up customized cricket cages, turf-integrated nets, and terrace cricket setups.',
    faqs: [{ q: 'Can we install it on a terrace?', a: 'Yes, we use light structural frame stands for roof installations.' }]
  },
  {
    id: 'sports-ball-stop-nets',
    title: 'Sports Ball Stop Nets',
    category: 'Sports Nets',
    shortDesc: 'High boundary netting fences for football, basketball, and tennis courts.',
    image: 'https://images.unsplash.com/photo-1508098682722-e99c43a406b2?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹18/sq.ft',
    benefits: ['Tall boundary grids', 'Friction proof nylon cords', 'Wind-shear slots', 'Tough ground anchors'],
    longDesc: 'Prevent sports balls from flying out of the playground, hitting nearby windows, or causing road accidents. Perfect for complexes and schools.',
    faqs: [{ q: 'How high can they be?', a: 'We construct poles and nets up to 30 feet in height.' }]
  },
  {
    id: 'football-ball-stop-nets',
    title: 'Football Ball Stop Nets',
    category: 'Sports Nets',
    shortDesc: 'Heavy cord ball stop nets designed to absorb high-impact football hits.',
    image: 'https://images.unsplash.com/photo-1508098682722-e99c43a406b2?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹22/sq.ft',
    benefits: ['Heavy cord thickness', 'Wide mesh size options', 'Resistant to hard football impacts', 'Strong framing lines'],
    longDesc: 'Specifically made for football yards and turf courts. The thick synthetic cords absorb ball speed, protecting audiences and neighboring yards.',
    faqs: [{ q: 'Are they weatherproof?', a: 'Yes, all our sports nets are 100% waterproof and UV-stabilized.' }]
  },
  {
    id: 'terrace-cricket-nets',
    title: 'Terrace Cricket Nets',
    category: 'Sports Nets',
    shortDesc: 'Box-cricket cages custom fit on building terraces.',
    image: 'https://images.unsplash.com/photo-1508098682722-e99c43a406b2?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹25/sq.ft',
    benefits: ['Rooftop box cricket setup', 'Full top and side screens', 'Strong wind resistance framework', 'Maximizes terrace space'],
    longDesc: 'Convert your empty apartment roof into a cricket turf. We provide custom box cricket setups with safety nets on all sides and ceiling.',
    faqs: [{ q: 'Does it require drilling into the terrace floor?', a: 'We use weight-balanced iron base structures to avoid roof damage.' }]
  },
  {
    id: 'sports-nets-installation',
    title: 'Sports Nets Installation',
    category: 'Sports Nets',
    shortDesc: 'Professional playground fencing and turf cage building services.',
    image: 'https://images.unsplash.com/photo-1508098682722-e99c43a406b2?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Toll-Free Installation Services',
    benefits: ['Expert ground installers', 'Heavy structural planning', 'High-tension cable rigs', 'Certified safety standards'],
    longDesc: 'From single pitch cages to large multi-sport complexes, our team provides safe structural setups and pole mounting installations.',
    faqs: [{ q: 'Do you offer warranty on installations?', a: 'Yes, we provide a 2-year warranty on our structural setups.' }]
  },
  {
    id: 'all-sports-nets',
    title: 'All Sports Nets',
    category: 'Sports Nets',
    shortDesc: 'Nets for badminton, volleyball, football goals, and custom athletic yards.',
    image: 'https://images.unsplash.com/photo-1508098682722-e99c43a406b2?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹18/sq.ft',
    benefits: ['Multi-sport configuration', 'High quality braids', 'Custom sizing', 'Easy dismantle options'],
    longDesc: 'Vengamamba Enterprises provides premium nets for all athletic sports. We design nets for schools, resorts, apartments, and private grounds.',
    faqs: [{ q: 'Can we get custom dimensions?', a: 'Yes, we customize size, thickness, and colors to match your requirements.' }]
  },

  // === CLOTH HANGERS ===
  {
    id: 'balcony-clothes-hangers',
    title: 'Balcony Clothes Hangers',
    category: 'Cloth Hangers',
    shortDesc: 'Space-saving dry hanger rods designed for balcony walls and ceilings.',
    image: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹1,200/set',
    benefits: ['Rust-proof aluminum pipes', 'Heavy load hooks', 'Space saving layout', 'Neat dry setup'],
    longDesc: 'Drying clothes in a small balcony is now easier. Our balcony clothes hangers fold back when not in use, maximizing space.',
    faqs: [{ q: 'Is it rust proof?', a: 'Yes, we use rust-proof aluminum and SS-304 pipes.' }]
  },
  {
    id: 'pulley-clothes-drying-hangers',
    title: 'Pulley Clothes Drying Hangers',
    category: 'Cloth Hangers',
    shortDesc: 'Individually adjustable ceiling ropes with smooth pulley lifts.',
    image: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹1,800/set',
    benefits: ['Individual rod pulley system', 'Heavy nylon lift ropes', 'No strain ceiling pull', 'Rust-proof pipes'],
    longDesc: 'Hang and dry clothes easily at the ceiling. Pull down each rod individually, hang the clothes, and pull it back up to dry, keeping the balcony floor free.',
    faqs: [{ q: 'How much weight can a rod hold?', a: 'Each rod can support up to 5kg of wet clothes.' }]
  },
  {
    id: 'roof-clothes-drying-hangers',
    title: 'Roof Clothes Drying Hangers',
    category: 'Cloth Hangers',
    shortDesc: 'Sturdy roof-anchored steel drying frame models.',
    image: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹1,500/set',
    benefits: ['Direct ceiling mount', 'Rigid framework', 'Holds heavy blankets', 'Corrosion-free finish'],
    longDesc: 'Sturdy, long-lasting hangers anchored directly into concrete ceilings. Designed to hold heavy laundry load items like blankets and bedsheets.',
    faqs: [{ q: 'Can it be installed on high ceilings?', a: 'Yes, we customize rope lengths to match any ceiling height.' }]
  },
  {
    id: 'ceiling-clothes-hangers',
    title: 'Ceiling Clothes Hangers',
    category: 'Cloth Hangers',
    shortDesc: 'Sleek vertical retractable ceiling-mounted cloth hangers.',
    image: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹2,000/set',
    benefits: ['Saves floor space', 'Retractable rope lifts', 'Strong SS steel rails', 'Clean indoor look'],
    longDesc: 'Premium indoor and balcony drying solutions. These ceiling-mounted hangers keep your laundry out of sight and secure.',
    faqs: [{ q: 'Can it be installed in utility areas?', a: 'Yes, it is highly suited for laundry and utility rooms.' }]
  },
  {
    id: 'wall-mounted-clothes-hangers',
    title: 'Wall Mounted Clothes Hangers',
    category: 'Cloth Hangers',
    shortDesc: 'Foldable accordian clothes hangers mounted on walls.',
    image: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=800&q=80',
    priceGuideline: 'Starts from ₹1,200/set',
    benefits: ['Accordion expandable style', 'Folds flat on wall', 'Perfect for small rooms', 'Rust-resistant coating'],
    longDesc: 'Sturdy wall-mounted racks that pull out when you need to dry clothes, and push back flat against the wall, taking zero space.',
    faqs: [{ q: 'What is the width?', a: 'We offer sizes from 2 feet to 4 feet width.' }]
  }
];

const defaultGallery = [
  { id: 'g1', title: 'Balcony Safety Net Installation', category: 'Balcony Safety Nets', image: '/balcony-safety-net.png', isBeforeAfter: false },
  { id: 'g2', title: 'Pigeon Net in Open Balcony Area', category: 'Pigeon Nets', image: '/pigeon-safety-net.png', isBeforeAfter: false },
  { id: 'g3', title: 'Box Cricket Setup on Terrace', category: 'Sports Nets', image: '/sports-net.png', isBeforeAfter: false },
  { id: 'g4', title: 'Invisible Grill Balcony View', category: 'Invisible Grills', image: '/invisible-grill.png', isBeforeAfter: false },
  { 
    id: 'g5', 
    title: 'Pigeon Netting Duct Installation', 
    category: 'Pigeon Nets', 
    image: '/pigeon-safety-net.png', 
    isBeforeAfter: true, 
    beforeImage: 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&w=800&q=80', 
    afterImage: '/pigeon-safety-net.png' 
  },
  { id: 'g6', title: 'Kids Balcony Protection Net', category: 'Kids Safety Nets', image: '/kids-safety-net.png', isBeforeAfter: false }
];

const defaultTestimonials = [
  { id: 't1', name: 'Krishna Rao', location: 'Kondapur, Hyderabad', rating: 5, review: 'Very professional work. Installed balcony safety nets within 3 hours of calling. The nets are almost invisible and sturdy.' },
  { id: 't2', name: 'Divya Reddy', location: 'Whitefield, Bangalore', rating: 5, review: 'We opted for invisible grills for our balcony and ceiling hangers. The quality is exceptional and view is perfect now. Highly recommend Vengamamba Enterprises!' },
  { id: 't3', name: 'Srinivas Murthy', location: 'Madhurawada, Visakhapatnam', rating: 4, review: 'Installed pigeon netting on our plumbing duct area. They took proper safety precautions during installation. Very neat job.' },
  { id: 't4', name: 'Anjali Shah', location: 'OMR, Chennai', rating: 5, review: 'Amazing service. Quick delivery and clear communication. The price is reasonable compared to other providers.' }
];

const defaultLocations = [
  { id: 'loc-hyd', name: 'Hyderabad', active: true, phone: '+91 98765 43210' },
  { id: 'loc-vij', name: 'Vijayawada', active: true, phone: '+91 98765 43211' },
  { id: 'loc-vzg', name: 'Visakhapatnam', active: true, phone: '+91 98765 43212' },
  { id: 'loc-blr', name: 'Bangalore', active: true, phone: '+91 98765 43213' },
  { id: 'loc-chn', name: 'Chennai', active: true, phone: '+91 98765 43214' }
];

const defaultWebSettings = {
  companyName: 'Vengamamba Enterprises',
  phone1: '+91 98765 43210',
  phone2: '+91 87654 32109',
  whatsappNumber: '+919876543210',
  email: 'info@vengamambasafetynets.com',
  address: 'Plot No. 45, Beside Metro Station, Madhapur, Hyderabad, Telangana - 500081',
  workingHours: 'Mon - Sun: 8:00 AM - 9:00 PM',
  mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.182470769395!2d78.3846669!3d17.4485535!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9158f201b905%3A0x73db4569d20c5d6e!2sMadhapur%20Metro%20Station!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin',
  meta: {
    home: { title: 'Best Balcony & Pigeon Safety Nets Installation Service | Vengamamba Enterprises', desc: 'Vengamamba Enterprises provides professional installation of Balcony Safety Nets, Pigeon Nets, Kids Nets, Invisible Grills & Sports Nets in Hyderabad, Bangalore, Chennai.' },
    about: { title: 'About Us | Vengamamba Enterprises - Certified Safety Nets Provider', desc: 'Learn about Vengamamba Enterprises, our mission, vision, strict quality standards, and our years of experience in offering safety netting solutions.' },
    gallery: { title: 'Our Installation Projects Gallery | Vengamamba Enterprises', desc: 'Browse our latest projects gallery showing Balcony Nets, Pigeon Nets, Sports Nets and Invisible Grills before/after installations.' },
    contact: { title: 'Contact Us | Safety Nets Call & WhatsApp Support | Vengamamba Enterprises', desc: 'Get in touch with Vengamamba Enterprises. Get a free quote for safety netting installation in Hyderabad, Vijayawada, Visakhapatnam, Bangalore, Chennai.' }
  },
  heroSlides: [
    {
      title: "Balcony Safety Nets",
      subtitle: "Professional Installation",
      image: "https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?auto=format&fit=crop&w=1600&q=80"
    },
    {
      title: "Invisible Grill For Balcony",
      subtitle: "Professional Installation",
      image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1600&q=80"
    },
    {
      title: "Pigeon Safety Nets",
      subtitle: "Professional Installation",
      image: "https://images.unsplash.com/photo-1596464716127-f2a82984de30?auto=format&fit=crop&w=1600&q=80"
    },
    {
      title: "All Types Of Hangers",
      subtitle: "Professional Installation",
      image: "https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=1600&q=80"
    },
    {
      title: "Children Safety Nets",
      subtitle: "Professional & Safe",
      image: "https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?auto=format&fit=crop&w=1600&q=80"
    },
    {
      title: "Cricket & Sports Nets",
      subtitle: "Heavy-Duty Quality",
      image: "https://images.unsplash.com/photo-1508098682722-e99c43a406b2?auto=format&fit=crop&w=1600&q=80"
    }
  ]
};

const defaultEnquiries = [
  { id: 'enq-1', name: 'Ramesh Kumar', email: 'ramesh@gmail.com', phone: '+91 9988776655', service: 'Balcony Safety Nets', location: 'Hyderabad', message: 'Need safety nets installed for my balcony on the 14th floor. Please send a quote.', date: '2026-06-28T10:15:00.000Z', status: 'unread' },
  { id: 'enq-2', name: 'Saranya Nathan', email: 'saranya@yahoo.com', phone: '+91 9845012345', service: 'Invisible Grills', location: 'Bangalore', message: 'Interested in invisible grills installation. Looking for a site visit.', date: '2026-06-27T14:30:00.000Z', status: 'read' }
];

const API_URL = import.meta.env.DEV ? 'https://vengamambaenterprises.com/api.php' : '/api.php';

const saveToBackend = async (key, data) => {
  try {
    const res = await fetch(`${API_URL}?action=save_data`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ key, data })
    });
    if (!res.ok) {
      throw new Error(`HTTP status ${res.status}`);
    }
    const result = await res.json();
    if (!result.success) {
      throw new Error(result.error || "Unsuccessful response");
    }
    console.log(`Successfully saved ${key} to backend.`);
  } catch (error) {
    console.error(`Error saving ${key} to backend:`, error);
  }
};

export const WebProvider = ({ children }) => {
  const [services, _setServices] = useState(defaultServices);
  const [gallery, _setGallery] = useState(defaultGallery);
  const [testimonials, _setTestimonials] = useState(defaultTestimonials);
  const [locations, _setLocations] = useState(defaultLocations);
  const [enquiries, setEnquiries] = useState([]);
  const [settings, _setSettings] = useState(defaultWebSettings);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadAllData = async () => {
      try {
        const res = await fetch(`${API_URL}?action=get_data`);
        if (!res.ok) throw new Error("HTTP error " + res.status);
        const result = await res.json();
        
        if (result.services !== null && result.services !== undefined) {
          _setServices(result.services);
        } else {
          _setServices(defaultServices);
          saveToBackend('services', defaultServices);
        }
        
        if (result.gallery !== null && result.gallery !== undefined) {
          _setGallery(result.gallery);
        } else {
          _setGallery(defaultGallery);
          saveToBackend('gallery', defaultGallery);
        }

        if (result.testimonials !== null && result.testimonials !== undefined) {
          _setTestimonials(result.testimonials);
        } else {
          _setTestimonials(defaultTestimonials);
          saveToBackend('testimonials', defaultTestimonials);
        }

        if (result.locations !== null && result.locations !== undefined) {
          _setLocations(result.locations);
        } else {
          _setLocations(defaultLocations);
          saveToBackend('locations', defaultLocations);
        }

        if (result.settings !== null && result.settings !== undefined) {
          _setSettings(result.settings);
        } else {
          _setSettings(defaultWebSettings);
          saveToBackend('settings', defaultWebSettings);
        }

        if (result.enquiries !== null && result.enquiries !== undefined) {
          setEnquiries(result.enquiries);
        }
      } catch (err) {
        console.error("Failed to load data from backend, using defaults:", err);
      } finally {
        setLoading(false);
      }
    };
    loadAllData();
  }, []);

  const setServices = (update) => {
    _setServices(prev => {
      const next = typeof update === 'function' ? update(prev) : update;
      saveToBackend('services', next);
      return next;
    });
  };

  const setGallery = (update) => {
    _setGallery(prev => {
      const next = typeof update === 'function' ? update(prev) : update;
      saveToBackend('gallery', next);
      return next;
    });
  };

  const setTestimonials = (update) => {
    _setTestimonials(prev => {
      const next = typeof update === 'function' ? update(prev) : update;
      saveToBackend('testimonials', next);
      return next;
    });
  };

  const setLocations = (update) => {
    _setLocations(prev => {
      const next = typeof update === 'function' ? update(prev) : update;
      saveToBackend('locations', next);
      return next;
    });
  };

  const setSettings = (update) => {
    _setSettings(prev => {
      const next = typeof update === 'function' ? update(prev) : update;
      saveToBackend('settings', next);
      return next;
    });
  };

  const addEnquiry = async (enquiry) => {
    const newEnq = {
      id: `enq-${Date.now()}`,
      date: new Date().toISOString().slice(0, 19).replace('T', ' '),
      status: 'unread',
      ...enquiry
    };
    setEnquiries(prev => [newEnq, ...prev]);
    try {
      await fetch(`${API_URL}?action=add_enquiry`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newEnq)
      });
    } catch (error) {
      console.error("Error saving enquiry to backend:", error);
    }
  };

  const markEnquiryRead = async (id) => {
    let updatedEnq = null;
    setEnquiries(prev => prev.map(enq => {
      if (enq.id === id) {
        updatedEnq = { ...enq, status: 'read' };
        return updatedEnq;
      }
      return enq;
    }));

    if (updatedEnq) {
      try {
        await fetch(`${API_URL}?action=add_enquiry`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(updatedEnq)
        });
      } catch (error) {
        console.error("Error updating enquiry status on backend:", error);
      }
    }
  };

  const deleteEnquiry = async (id) => {
    setEnquiries(prev => prev.filter(enq => enq.id !== id));
    try {
      await fetch(`${API_URL}?action=delete_enquiry`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id })
      });
    } catch (error) {
      console.error("Error deleting enquiry from backend:", error);
    }
  };

  const resetAllData = async () => {
    setServices(defaultServices);
    setGallery(defaultGallery);
    setTestimonials(defaultTestimonials);
    setLocations(defaultLocations);
    setEnquiries(defaultEnquiries);
    setSettings(defaultWebSettings);

    try {
      await fetch(`${API_URL}?action=reset_data`, { method: 'POST' });
    } catch (error) {
      console.error("Error resetting data in backend:", error);
    }
  };

  return (
    <WebContext.Provider value={{
      services, setServices,
      gallery, setGallery,
      testimonials, setTestimonials,
      locations, setLocations,
      enquiries, setEnquiries,
      settings, setSettings,
      addEnquiry, markEnquiryRead, deleteEnquiry,
      resetAllData
    }}>
      {children}
    </WebContext.Provider>
  );
};

export const useWeb = () => {
  const context = useContext(WebContext);
  if (!context) {
    throw new Error('useWeb must be used within a WebProvider');
  }
  return context;
};
